// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3vI0s","description":"PatientConsentPreview_description__mT3vb"};